import LocalImage from "@common/components/LocalImage";
import Button from "@components/Button";
import SaveMoreVehicleCardDetails from "../types/saveMoreVehicleCardDetails";

type Props = {
  cardDetails: SaveMoreVehicleCardDetails;
};

const SaveMoreVehicleCard = ({ cardDetails }: Props) => {
  return (
    <div className="group rounded-lg shadow-elevation-00 overflow-hidden aspect-none pb-4 min-h-[26rem] bg-white">
      <div className="items-center justify-center text-center h-full max-h-[24rem]">
        <div className={cardDetails.backgroundImage.ellipseColour}>
          <div className="relative z-0">
            <div>
              <svg
                fill="white"
                className={`w-full h-full absolute -bottom-1 justify-center items-center z-10 ${cardDetails.backgroundImage.ellipseColour}`}
              >
                <ellipse
                  overflow="hidden"
                  cx="50%"
                  cy="100%"
                  rx="60%"
                  ry="30%"
                />
              </svg>
              <div className="flex flex-wrap justify-center">
                <div className="w-3/4 px-4 pt-6 mb-2">
                  <LocalImage
                    src={cardDetails.backgroundImage.src}
                    alt={cardDetails.backgroundImage.altText}
                    className="z-20 relative h-auto align-middle border-none object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="px-5 w-full flex flex-col">
          <div className="m-auto">
            {cardDetails.cardHeading && (
              <div>
                <p className="font-semibold text-primary-bold text-2xl">
                  {cardDetails.cardHeading}
                </p>
              </div>
            )}

            {cardDetails.cardSubHeading && (
              <div className="pt-2">
                <p className="font-semibold text-primary-deep text-xl">
                  {cardDetails.cardSubHeading}
                </p>
              </div>
            )}

            {cardDetails.cardDescription && (
              <div className="pt-2">
                <p className="font-medium text-text-light-200">
                  {cardDetails.cardDescription}
                </p>
              </div>
            )}

            {cardDetails.cardButton && (
              <div className="pt-5">
                <Button
                  className="caption-1"
                  fill="filled"
                  buttonStyle="primary"
                  onClick={cardDetails.cardButton.onClick}
                >
                  {cardDetails.cardButton.title}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveMoreVehicleCard;
